import { getServiceUrl, selectAPIService } from '@/app/_utils/select-api-service'
import { setUrlParams } from '@/app/_utils/set-url-params'

export async function getPDPData(slug: string) {
    const apiService = selectAPIService()
    const baseUrl = getServiceUrl(apiService.ntl)
    const url = `${baseUrl}/products/slug/${slug}`
    const finalUrl = setUrlParams(url)

    // eslint-disable-next-line no-console
    process.env.NODE_ENV !== 'production' && console.log('URL ==> %s', finalUrl)

    try {
        const response = await fetch(finalUrl, { cache: 'no-cache' })
        const result = await response.json()

        if (!response.ok) {
            const errorCodes = result.errors[0].code
            const statusCode = response.status

            if (
                statusCode === 404 ||
                errorCodes === 'entity.not.found' ||
                errorCodes === 'invalid.input' ||
                errorCodes === 'product_not_found' ||
                errorCodes === 'invalid.slug'
            ) {
                return null
            } else {
                throw new Error(`Fetching PDP data ${finalUrl} failed. Status Code: ${response.status}`)
            }
        }

        return result?.data
    } catch (error) {
        throw new Error(`${error}`)
    }
}
